import { Filter } from "@/common/model/Filter";
import { Nullable } from "@/general/custom-types/CustomTypes";

export class SensorFilter extends Filter {
  customer?: Nullable<number[]>;
  facility?: Nullable<number[]>;
  dataLogger?: Nullable<number[]>;
  location?: Nullable<number[]>;
  meterNumber?: Nullable<string>;
  sensor?: Nullable<number>;

  constructor(
    customer?: Nullable<number[]>,
    facility?: Nullable<number[]>,
    dataLogger?: Nullable<number[]>,
    deviceNumber?: Nullable<number>,
    location?: Nullable<number[]>,
    meterNumber?: Nullable<string>,
    sensor?: Nullable<number>
  ) {
    super("sensor-filter");
    this.customer = customer;
    this.facility = facility;
    this.dataLogger = dataLogger;
    this.location = location;
    this.meterNumber = meterNumber;
    this.sensor = sensor;
  }

  clear(): void {
    this.customer = null;
    this.facility = null;
    this.dataLogger = null;
    this.location = null;
    this.meterNumber = null;
    this.sensor = null;
  }

  toQueryParam(): string {
    let query: string = "";
    if (this.customer && this.customer.length > 0) {
      query += `&customer=${this.customer}`;
    }
    if (this.facility && this.facility.length > 0) {
      query += `&facility=${this.facility}`;
    }
    if (this.dataLogger && this.dataLogger.length > 0) {
      query += `&dataLogger=${this.dataLogger}`;
    }
    if (this.sensor) {
      query += `&sensor=${this.sensor}`;
    }
    if (this.meterNumber) {
      query += `&meterNumber=${this.meterNumber}`;
    }
    if (this.location) {
      query += `&location=${this.location}`;
    }
    return query;
  }
}
